import React from "react";
import { useEffect, useState } from "react";
import CacheLoadCredentials from "../../usecases/CacheLoadCredentials";
import UserGetData from "../../usecases/UserGetData";
import RowContainer from "../basic/RowContainer";
import RowContainerItem from "../basic/RowContainerItem";
import UsersList from '../specific/UsersList'
import BasicCard from "../basic/BasicCard";
import Refresh from "../basic/Refresh";
import { IconButton } from "@mui/material";
import DateFormat from "../../usecases/DateFormat";
import { Info } from "@mui/icons-material";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Pages from "../../pages/Pages";


function User () {
    const history = useHistory();
    const[usuarioLogado, setUsuarioLogado] = useState(null);
    const[users, setUsers] = useState([]);
    const[loading, setloading] = useState(false);

    useEffect(() => {
        CacheLoadCredentials().then(res => {
            if(res && res.tipo)
            setUsuarioLogado(res)
        })
        getUsers()
    }, [])

    const bindData = (data)=>{
        let binded=[];
        
        binded = data.map((item, i)=>{
            let obj = {} 
            
                obj.info =  (<IconButton color="info" onClick={()=>redirectUser(item)}><Info/></IconButton>)
                obj.nome = item.nome
                obj.data = item.data_update_server
                obj.tipo = item.tipo
                obj.email = item.email
                obj.telefone = item.telefone
                obj.autorizado = item.autorizado
                obj.emailconfirmado = item.emailconfirmado
                obj.quantidade_equips = item.quantidade_equips
                obj.id = item.id
                return obj
        })
        return binded;  
    }

    function redirectUser(item){
        history.push(Pages.routes.Users)
    }

    const getUsers = () => {
        setloading(true)
        UserGetData().then(items => {
            setUsers(bindData(items))
        })
        .catch(err => {
            console.error('Erro: ', err)
        })
        .finally(() => {
            setloading(false)
        })
    }

    

    return(
        <div>
            {/* <RowContainer>
                <RowContainerItem style={{display:'flex', flex: 1, flexDirection: 'column'}}>
                    <BasicCard style={{ flex: 1, textAlign: 'left', fontFamily: 'Times New Roman', color:"#F8C102", fontWeight: 'bold', fontSize: 40}} title="Grafico de Usuarios geral">
                        <div>Implementação futura</div>
                    </BasicCard>
                </RowContainerItem>
                <RowContainerItem style={{display:'flex', flex: 1, flexDirection: 'column'}}>
                    <BasicCard style={{ flex: 1, textAlign: 'left', fontFamily: 'Times New Roman', color:"#F8C102", fontWeight: 'bold', fontSize: 40}} title="Grafico de distribuição de Usuarios">
                        <div>Implementação futura</div>
                    </BasicCard>
                </RowContainerItem>
                <RowContainerItem style={{display:'flex', flex: 1, flexDirection: 'column'}}>
                    <BasicCard style={{ flex: 1, textAlign: 'left', fontFamily: 'Times New Roman', color:"#F8C102", fontWeight: 'bold', fontSize: 40}} title="Grafico de Usuarios por Periodo">
                        <div>Implementação futura</div>
                    </BasicCard>
                </RowContainerItem>
            </RowContainer> */}
            <RowContainer>
                <RowContainerItem minWidth={400}>
                    <BasicCard>
                    <UsersList
                        style={{flex:1, width:'100%', maxWidth:'100%'}} 
                        items = {users}
                        rowsPerPage = {15}
                        usuarioLogado = {usuarioLogado}
                        refresh = {getUsers}
                        loading = {loading}
                    />
                    <Refresh onClick={getUsers} />
                    </BasicCard>
                </RowContainerItem>
            </RowContainer>
        </div>
    )   
}

export default User;